export function extractCypressLocatorDataTestidAttribute(props) {
    return {
        "data-testid": props["data-testid"],
    };
}
//# sourceMappingURL=extractCypressLocatorDataTestidAttribute.js.map